<template lang="pug">
  .mr-navigation
    header.container(:class='[{ "dark-header": showMensMenu}, headerClass]')
      .top-nav.row.text-center.xs-f-small.md-f-medium.lg-f-small.max-at-tweak(:class="{ open: topNavMobileNavOpen }")
        MrSiteSearch

        template(v-if='cmsSettings && cmsSettings.showMegaNav')
          .mega-nav.xs-f-xsmall.max-at-tweak.xs-12
            .xs-12.md-6.lg-3
              .mega-nav-item.womens-nav-item.xs-6
                a(href='').upper
                  span Women's
                .selected-strip

              .mega-nav-item.mens-nav-item.xs-6
                a(href='/men').upper
                  span Men's

        .top-wrap.xs-12
          //- show left hamburger if user fulfills any of the following
              - not logged in
              - has not made an order
          .left-wrap
            button#hamburger.lg-hide(type="button"  v-if="showHamburgerMenu && showNavs"  @click="toggleHamburger"  :class="{ open: topNavMobileNavOpen }"  data-mr-ass="hamburger-menu")
              .stripe-top
              .stripe-bottom

            template(v-if="!showMensMenu")
              // Desktop/tablet search icon shows everytime
              button.search-trigger.btn-reset.color-black.xs-hide.sm-hide.md-hide.lg-f-small.max-at-tweak(@click="toggleSearch")
                span.upper.xs-f-xsmall.md-f-small.lg-f-xsmall.max-at-tweak search&nbsp;
                span.icon-magnify

              // Mobile search icon shows only if the hamburger menu is not visible
              button.search-trigger.btn-reset.color-black.xs-f-medium.md-f-xmedium.lg-hide.max-at-tweak(v-if="!showHamburgerMenu || !showNavs" @click="toggleSearch")
                span.icon-magnify
                  span.ada-tooltip open search

          .middle-wrap
            template(v-if='showMensMenu')
              a(href='/men').mr-mister-logo.color-white
                mr-icon(name="mr-mister-logo" width="263" height="29")
                span.ada-tooltip home

            template(v-else)
              a.mr-logo(href='/' target="_self")
                span.ada-tooltip home

          .right-wrap
            button.btn-reset.coupons.xs-mr-50m(v-if="couponCount" @click="showCouponDrawer")
              PromoTagCounter

            a.icon-bag.color-black(href='/cart' target="_self")
              span.ada-tooltip go to cart
              .item-count
                span {{cic}}

            .login-wrap.xs-hide.sm-hide.md-hide(v-if="!hideLogin")
              button.login.btn-reset.upper.color-black.xs-f-xsmall.md-f-small.lg-f-xsmall.max-at-tweak(@click="openLogInModal" target="_self" data-mr-ass="log-in-nav" aria-label="Log In") Log In

        //- show "account" / "login" tab if user fulfills any of the following
            - not logged in
            - has not made an order
        .mr-unlogged-nav-bar(v-if="showNavs")
          template(v-if='showMensMenu')
            MensMenu(:class="{ open: topNavMobileNavOpen }" v-on:open-sign-in-control="openLogInModal")

          template(v-else)
            site-nav

      TopMenu(v-if="showRCDishHorizontalNav"  :all-out="true")
</template>

<script>
import {mapActions, mapMutations, mapState, mapGetters} from "vuex";
import MrSiteSearch from '@components/mrSiteSearch';
import { logout } from "@services/vueCustomerSvc";
import trackEventMixin from "@mixins/trackEventMixin";
import cartMixin from "@mixins/cartMixin";
import SiteNav from "@components/SiteNav";
import PromoTagCounter from "@components/PromoTagCounter/PromoTagCounter";

export default {
  name: "MrNavigation",

  components: {
    PromoTagCounter,
    TopMenu: () => import('../Dashboard/TopMenu'),
    MensMenu: () => import('../MensMenu'),
    MrSiteSearch,
    SiteNav
  },

  mixins: [
    trackEventMixin,
    cartMixin,
  ],

  inject: ['getObjProperty'],

  data() {
    return {
      promoDrawerCookie: 'promoDrawerSeen'
    };
  },

  computed: {
    ...mapState('global', ['topNavSelected',
      'topNavMobileNavOpen',
      'navItems',
      'windowData',
      'isApp',
      'headerClass',
      'showHamburgerMenu',
      'hideLogin',
      'showRCDishHorizontalNav',
      'showNavs'
    ]),
    ...mapState('customer', ['cdata', 'info']),
    ...mapState('cms', ['cmsSettings']),
    ...mapGetters('customer', ['unlimitedRootsMembership', 'directMembership']),
    ...mapGetters('global', ['showMensMenu']),
    ...mapGetters('coupons', [
      'couponCount'
    ]),

    activeCdataSubs() {
      return this.getObjProperty(this, 'cdata.activeSubscriptions') || [];
    },

    hasMoreThanUnlimitedRootsMembership() {
      return Boolean(this.activeCdataSubs.filter(subs => subs.productType !== 'renewable_cb_membership').length);
    },

    hasMoreThanCanceledUnlimitedRootsMembership() {
      let canceledSubTypes = this.getObjProperty(this, 'cdata.canceledSubTypes') || {};
      return Boolean(Object.keys(canceledSubTypes).filter(subType => subType !== 'renewable_cb_membership').length);
    },

    hasMoreThanDirectMembership() {
      return Boolean(this.activeCdataSubs.filter(subs => subs.productType !== 'omni_memb').length);
    },

    customerInfo() {
      return this.$store.state.customer.info;
    },
  },

  watch: {
    cdata(cData) {
      if (!cData) {
        return;
      }

      this.determineDynamicNavItems();
    },

    directMembership(directMembership) {
      if (directMembership) {
        this.determineDynamicNavItems();
      }
    },

    info: {
      immediate: true,
      handler (info) {
        if (info.authed) {
          let menuItem = {
            text: 'LOG OUT',
            method: this.confirmLogout,
          };
          this.addMenuItem(menuItem);
        }
      },
    },
  },

  async mounted() {
    this.determineDynamicNavItems();
    // we only want to track viewed event for the first time they see the experiment during the session (both versions)
    if (!this.$cookies.get(this.promoDrawerCookie)) {
      this.$cookies.set(this.promoDrawerCookie, 1);
    }
  },

  methods: {
    ...mapMutations('global', [
      'addMenuItem',
      'removeMenuItem',
      'setWindowData',
      'setTopNavSelected',
      'setTopNavMobileNavOpen',
    ]),

    ...mapActions('siteNav', [
      'toggleMobileSiteNav'
    ]),

    ...mapActions('global', [
      'toggleSearch'
    ]),

    ...mapActions('coupons', [
      'openCouponDrawer'
    ]),

    ...mapActions('modal', ['showModal', 'showPrompt']),

    showCouponDrawer() {
      this.openCouponDrawer();
      this.trackMREvent('Header - Promo Drawer Opened');
    },

    openLogInModal() {
      let payload = {
        component: './MrSignIn',
        theme: 'signin',
      };

      this.showModal(payload);
    },

    confirmLogout() {
      let promptPayload = {
        component: './ConfirmDialogTemplate',
        theme: 'flex-width',
        confirm: this.logOut,
        confirmText: 'Log Out',
        title: 'Log Out',
        text: 'Please confirm you want to sign out of your Madison Reed account.',
        centerText: true,
      };

      this.showPrompt(promptPayload);
    },

    logOut() {
      this.$cookies.remove('amazon_Login_state_cache');
      this.$cookies.remove('amazon_Login_accessToken');
      this.$cookies.remove('amazon_Address_consentToken');

      localStorage.removeItem('ajs_group_properties');
      localStorage.removeItem('ajs_user_traits');

      logout().then(() => {
        this.mix_trackEvent('Logged Out');
        window.analytics.reset();
        window.location = '/';
      });
    },

    toggleHamburger() {
      if (!this.showMensMenu) {
        this.toggleMobileSiteNav();
      } else {
        this.setTopNavMobileNavOpen(!this.topNavMobileNavOpen);
      }
    },

    determineDynamicNavItems() {
      let subscriptionMenuIndex = 1;
      let orderMenuIndex = 1;

      if (this.unlimitedRootsMembership || this.directMembership) {
        this.addMenuItem({
          url: '/dashboard/membership',
          text: 'Membership',
          index: 1,
        });
        subscriptionMenuIndex++;
        orderMenuIndex++;
      } else {
        this.removeMenuItem('Membership');
      }

      //- add 'Subscriptions' menu items if user has any active or past subscriptions and it is not only unlimited roots membership
      if (
        (this.cdata.activeSubscriber && this.hasMoreThanUnlimitedRootsMembership && this.hasMoreThanDirectMembership) ||
        this.hasMoreThanCanceledUnlimitedRootsMembership
      ) {
        let menuItem = {
          url: '/dashboard/subscriptions',
          text: 'Subscriptions',
          index: subscriptionMenuIndex,
        };

        this.addMenuItem(menuItem);
        orderMenuIndex++;
      }

      //- add 'Orders' menu items if user has any existing or pending orders
      if (this.cdata.ordersTotal > 0 || ((Array.isArray(this.cdata.pendingOrders) && this.cdata.pendingOrders.length > 0))) {
        let ordersMenuItem = {
          url: '/dashboard/orders',
          text: 'Orders',
          index: orderMenuIndex,
        };

        this.addMenuItem(ordersMenuItem);
      }
    }
  }
};
</script>

<style lang="stylus">
  .mr-navigation
    .coupons
      display inline-block
      vertical-align top

</style>
